import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, TrendingDown, Zap } from 'lucide-react';

export const ProblemSection = () => {
  return (
    <section className="py-24 sm:py-32 bg-[#050505]">
      <div className="max-w-5xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl sm:text-5xl font-headline font-bold text-[#F4F4F5] mb-6">
            Every missed call is a{' '}
            <span className="gradient-text">donation to your competitor.</span>
          </h2>
          <p className="text-lg sm:text-xl text-[#A1A1AA] font-body leading-relaxed max-w-3xl mx-auto">
            You spend thousands on Google Ads and SEO, but if you do not answer the phone by the third ring, the customer is already calling the next guy on the list.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="glass p-8 rounded-xl border-l-4 border-[#FF453A]"
          >
            <AlertTriangle className="w-12 h-12 text-[#FF453A] mb-4" />
            <h3 className="text-xl font-headline font-bold text-[#F4F4F5] mb-3">The Problem</h3>
            <p className="text-[#A1A1AA] font-body leading-relaxed">
              You are too busy to answer, and office staff is too expensive to run 24/7.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="glass p-8 rounded-xl border-l-4 border-[#FFB020]"
          >
            <TrendingDown className="w-12 h-12 text-[#FFB020] mb-4" />
            <h3 className="text-xl font-headline font-bold text-[#F4F4F5] mb-3">The Reality</h3>
            <p className="text-[#A1A1AA] font-body leading-relaxed">
              <span className="text-[#00E599] font-bold text-2xl">67%</span> of customers hire the first pro who actually answers the phone.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="glass p-8 rounded-xl border-l-4 border-[#00E599]"
          >
            <Zap className="w-12 h-12 text-[#00E599] mb-4" />
            <h3 className="text-xl font-headline font-bold text-[#F4F4F5] mb-3">The Solution</h3>
            <p className="text-[#A1A1AA] font-body leading-relaxed">
              An AI employee that sounds human, knows your pricing, and never misses a ring.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
